import { HTTP } from "./http";
let API_SERVER = "";
if (window.location.href.indexOf("8080") > -1) {
  API_SERVER = "http://www.localhost:8888/back-end-endpoint-games.php";
} else {
  API_SERVER = "/personal-training-BE/back-end-endpoint-games.php";
}

const Games = {
  find(params) {
    return HTTP.post(API_SERVER, params);
  },

  show(id) {
    return HTTP.get(`users/${id}`);
  },

  store(post) {
    return HTTP.post("users", post);
  },

  update(post, id) {
    return HTTP.put(`users/${id}`, post);
  },

  delete(id) {
    return HTTP.delete(`users/${id}`);
  },
};

export { Games };
